import { useMemo } from 'react'
import { useWatch } from 'react-hook-form'
import { filterDefaultValues } from '../filterSettings'

const isArrayActive = arr => Array.isArray(arr) && arr.length > 0

const useActiveFilterCount = control => {
  const recurrenceType = useWatch({ control, name: 'serviceList.recurrenceType', defaultValue: filterDefaultValues.recurrenceType })
  const measure = useWatch({ control, name: 'serviceList.measure', defaultValue: filterDefaultValues.measure })
  const material = useWatch({ control, name: 'serviceList.material', defaultValue: filterDefaultValues.material })
  const action = useWatch({ control, name: 'serviceList.action', defaultValue: filterDefaultValues.action })
  const businessLine = useWatch({ control, name: 'serviceList.businessLine', defaultValue: filterDefaultValues.businessLine })
  const recurrenceFrequency = useWatch({
    control,
    name: 'serviceList.recurrenceFrequency',
    defaultValue: filterDefaultValues.recurrenceFrequency,
  })
  const recurrenceOption = useWatch({ control, name: 'serviceList.recurrenceOption', defaultValue: filterDefaultValues.recurrenceOption })
  const method = useWatch({ control, name: 'serviceList.method', defaultValue: filterDefaultValues.method })
  const pricingPeriod = useWatch({ control, name: 'serviceList.pricingPeriod', defaultValue: filterDefaultValues.pricingPeriod })
  const pricingZone = useWatch({ control, name: 'serviceList.pricingZone', defaultValue: filterDefaultValues.pricingZone })

  return useMemo(() => {
    let count = 0
    if (recurrenceType && recurrenceType !== filterDefaultValues.recurrenceType) count += 1
    if (isArrayActive(measure)) count += 1
    if (isArrayActive(material)) count += 1
    if (isArrayActive(action)) count += 1
    if (isArrayActive(businessLine)) count += 1
    if (isArrayActive(method)) count += 1
    if (isArrayActive(pricingPeriod)) count += 1
    if (isArrayActive(pricingZone)) count += 1
    if (recurrenceFrequency) count += 1
    if (recurrenceOption) count += 1
    return count
  }, [recurrenceType, measure, material, action, businessLine, method, pricingPeriod, pricingZone, recurrenceFrequency, recurrenceOption])
}

export default useActiveFilterCount
